window.onload = async () => {
	const product = window.Shopify.currentProduct;
	const isPOA = window.Shopify.currentProductIsPOA;

	if (!product) {
		return;
	}

	const $addToCartButton = document.querySelector('form.product-form-main button[name="add"]');
	const $addToHireButton = document.querySelector('form.product-form-main .button--hire');
	// console.log($addToCartButton);
	console.log($addToHireButton);

	/**
	 * Get all the possible purchaseable options for this product, including the selectable attributes to make the controls around
	 */
	const request = await fetch(apiURL, {
		method: 'POST',
		headers: {
			'Content-type': 'application/json',
			'X-Shopify-Storefront-Access-Token': 'fc51ae85a6fe893da9e4e363408ca435',
		},
		body: JSON.stringify({
			query: graphQuery,
			variables: {
				id: `gid://shopify/Product/${window.Shopify.currentProduct.id}`,
				countryCode: window.Shopify.country,
			},
		}),
	});

	const result = await request.json();
	let options = [];
	var selected = [];
	var selectedCosts = [];
	const $idInput = document.querySelector('form.product-form-main input[type="hidden"][name="id"]');
	const $skuElement = document.querySelector('.section-product__details__sku > span');

	// spread the various sub-products and their variants into one flat array
	for (const row of result.data.product.sub_product_group.reference.products.references.nodes) {
		options.push(
			...row.variants.nodes.map(option => {
				return {
					...option,
					values: option.title.split('|').map(t => t.trim()), // split the title into option values as that's how they're saved
				};
			})
		);
	}

	/**
	 * Scans through the available options and returns a valid list of options for a single attribute, given the current selection
	 * @param {number} optionIndex the index of the option we're looking to populate
	 * @param {array} selected flat array of currently selected values to filter based on
	 * @returns
	 */
	const enumerateOptions = async (optionIndex = 0) => {
		let a = []; // valid options

		let mins = {}; // map of option_name:minimum price so far

		variantLoop: for (let variant of options) {
			let variantValue = variant.values[optionIndex];

			// is this variant invalidated by previous selections?
			if (selected.length) {
				let index = 0;
				for (selectedValue of selected) {
					if (variant.values[index++] !== selectedValue && index <= optionIndex) {
						continue variantLoop;
					}
				}
			}

			if (!variantValue) {
				continue variantLoop;
			}

			mins[variantValue] = Math.min(mins[variantValue] || Number.POSITIVE_INFINITY, parseFloat(variant.price.amount));
			if (!a.includes(variantValue)) {
				a.push(variantValue);
			}
		}

		return a
			.sort()
			.map(a => {
				return {
					value: a,
					cost: parseInt(mins[a] * 100) - Shopify.currentProduct.price - selectedCosts.reduce((s, a) => s + a, 0) || 0,
				};
			})
			.sort((a, b) => a.cost - b.cost);
	};

	const createOptionElements = async (options, select, optionLabel = '') => {
		// clear any old options, then add back in a default one
		select.innerHTML = '';

		let defaultOptionEl = document.createElement('option');
		defaultOptionEl.innerHTML = `${window.cakeChooseLabel} ${optionLabel}`;
		defaultOptionEl.value = '';
		defaultOptionEl.setAttribute('disabled', true);
		defaultOptionEl.setAttribute('selected', true);
		select.append(defaultOptionEl);

		// loop through adding new options
		for (let { value, cost } of options) {
			let costString = Shopify.formatMoney(cost, Shopify.money_format);

			let optionEl = document.createElement('option');
			optionEl.value = value;
			optionEl.dataset.cost = cost;
			optionEl.innerHTML = cost && !isPOA ? `${value} +${costString}` : value;
			select.append(optionEl);
		}
	};

	/**
	 * Create the select fields and groups for selecting a variant
	 */
	const selectableOptions = JSON.parse(result.data.product.sub_product_group.reference.options.value);
	const selectTemplate = document.getElementById('sub_product_option');
	const subProductSelectors = document.getElementById('sub_products');

	for (let option of selectableOptions) {
		const optionKey = option
			.replaceAll(/[\(\),]+/g, '')
			.replaceAll(/[\s-/]+/g, '_')
			.toLowerCase();
		const clone = selectTemplate.content.cloneNode(true);
		const label = clone.querySelector('label');
		const select = clone.querySelector('select');

		label.innerHTML = option;
		label.setAttribute('for', optionKey);
		select.setAttribute('name', optionKey);
		select.setAttribute('id', optionKey);

		subProductSelectors.appendChild(clone);
	}

	/**
	 * Populate the first select field with a full, unfiltered list of options
	 */
	createOptionElements(await enumerateOptions(), subProductSelectors.querySelector('.sub_products__option-wrap:first-of-type select'), selectableOptions[0]);

	/**
	 * Add event listeners for the selects to display the next set of options if available
	 */
	const optionSelects = document.querySelectorAll('.sub_products__option-selector');

	optionSelects.forEach((select, index) =>
		select.addEventListener('change', async e => {
			selectedCosts.splice(index, selectedCosts.length - index);
			selected.splice(index, selected.length - index);

			if (select.value) {
				selected[index] = select.value;
				selectedCosts[index] = parseInt(select.selectedOptions[0]?.dataset.cost);
			}

			updateButtons();

			if (optionSelects[index + 1]) {
				createOptionElements(await enumerateOptions(index + 1), optionSelects[index + 1], selectableOptions[index + 1]);

				setPrice(Shopify.currentProduct.price);
				// SET COMPARE
				setComparePrice(Shopify.currentProduct.compareAtPrice);
				if (Shopify.currentProduct.variants[0].sku !== null) {
					$skuElement.innerHTML = `SKU: ${Shopify.currentProduct.variants[0].sku}`;
				}

				for (let i = index + 1; i < optionSelects.length; i++) {
					optionSelects[i].value = '';
				}
			} else if (select.value) {
				const validOption = options
					.filter(variant => {
						let i = 0;
						// if the title of this product matches all selected options, it's our one
						for (v of variant.title.split('|').map(t => t.trim())) {
							if (v !== selected[i++]) {
								return false;
							}
						}
						return true;
					})
					?.pop();

				console.log(validOption);
				setPrice(Math.round(parseFloat(validOption.price.amount) * 100));

				// COMPARE
				if (validOption.compareAtPrice && validOption.compareAtPrice.amount) {
					setComparePrice(Math.round(parseFloat(validOption.compareAtPrice.amount) * 100));
				}

				$idInput.value = validOption.id.split('/').pop();
				$skuElement.innerHTML = `SKU: ${validOption.sku}`;
			} else {
				setPrice(Shopify.currentProduct.price);

				// COMPARE
				setComparePrice(Shopify.currentProduct.compareAtPrice);
				$skuElement.innerHTML = `SKU: ${Shopify.currentProduct.variants[0].sku}`;
			}

			console.log(selectedCosts, selected);
		})
	);

	const priceElements = document.querySelectorAll(`
        .product-form span.final-price-display, 
        .product-form span.product-price-display
    `);
	const priceLabelElement = document.querySelector('.section-product__details__configuration-price .price-from');

	// QUERY SELECT COMPARE ELEMENT
	const priceCompareAtElements = document.querySelectorAll('.product-form .product-price-compare');

	function setPrice(price) {
		priceElements.forEach(el => {
			el.innerHTML = Shopify.formatMoney(price, Shopify.money_format);
			el.dataset.price = price;
			el.dataset.original = price;
		});
		window.checkVatPreference();
	}

	// FUNCTION TO SET COMPARE PRICE
	function setComparePrice(compareAtPrice) {
		if (!compareAtPrice) {
			for (const priceCompareAt of priceCompareAtElements) priceCompareAt.closest('.compare').classList.add('hidden');
			for (const el of priceElements) el.classList.remove('sale');
			return;
		}

		for (const priceCompareAt of priceCompareAtElements) {
			priceCompareAt.closest('.compare').classList.remove('hidden');
			priceCompareAt.innerHTML = Shopify.formatMoney(compareAtPrice, Shopify.money_format);
			priceCompareAt.dataset.price = compareAtPrice;
			priceCompareAt.dataset.original = compareAtPrice;
		}

		priceElements.forEach(el => {
			el.classList.add('sale');
		});

		window.checkVatPreference();
	}

	function updateButtons() {
		// changed this as it was returning false when "from" label didnt exist but the button did - Alex
		if (priceLabelElement) {
			if (selected.length === optionSelects.length) {
				priceLabelElement.classList.add('hidden');
			} else {
				priceLabelElement.classList.remove('hidden');
			}
		}
		if ($addToCartButton) {
			if (selected.length === optionSelects.length) {
				$addToCartButton.querySelector('.button-label').innerHTML = window.cakeAddToCartLabel;
				$addToCartButton.classList.add('button--primary');
				$addToCartButton.classList.remove('button--disabled');
				$addToCartButton.classList.remove('expansive');
			} else {
				$addToCartButton.classList.remove('button--primary');
				$addToCartButton.querySelector('.button-label').innerHTML = window.cakeChooseOpionsLabel;
				$addToCartButton.classList.add('button--disabled');
				$addToCartButton.classList.add('expansive');
			}
		}
		if ($addToHireButton) {
			if (selected.length === optionSelects.length) {
				$addToHireButton.disabled = false;
			} else {
				$addToHireButton.disabled = true;
			}
		}
	}
	updateButtons();

	$addToCartButton?.addEventListener('click', e => {
		if (selected.length !== optionSelects.length) {
			e.preventDefault();
			optionSelects[selected.length].focus();
			return false;
		}
	});
};

const apiURL = `https://${window.Shopify.shop}/api/2025-10/graphql.json`;

const graphQuery = `
query($id: ID!, $countryCode: CountryCode) @inContext(country: $countryCode) {
    product(id: $id) {
        id
        title
        sub_product_group: metafield(namespace: "custom", key: "sub_product_group") {
            reference {
                ... on Metaobject {
                    options: field(key: "options") {
                        value
                    }
                    products: field(key: "products") {
                        references(first: 50) {
                            nodes {
                                ... on Product {
                                    variants(first: 100) {
                                        nodes {
                                            id
                                            title
                                            sku
                                            price {
                                                amount
                                                currencyCode
                                            }
																						compareAtPrice {
																							amount
																							currencyCode
																						}
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
`;
